import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoriesService } from 'src/app/services/categori.service';

function passwordMatch(control: AbstractControl): ValidationErrors | null {
  const newPw = control.get('new_password')?.value;
  const confirmPw = control.get('confirm_password')?.value;
  return newPw === confirmPw ? null : { mismatch: true };
}

@Component({
  standalone: false,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  form: FormGroup | any;
  loading = false;
  done = false;
  token = '';

  constructor(
    private rest: CategoriesService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';

    this.form = new FormGroup(
      {
        new_password: new FormControl('', [Validators.required, Validators.minLength(8)]),
        confirm_password: new FormControl('', [Validators.required]),
      },
      { validators: passwordMatch }
    );
  }

  submit() {
    if (!this.form.valid) {
      if (this.form.errors?.['mismatch']) {
        this.rest.errorToaster('toast.passwords_no_match');
      }
      return;
    }
    this.loading = true;
    const payload = { token: this.token, new_password: this.form.value.new_password };
    this.rest.resetPassword(payload).subscribe(
      (res: any) => {
        this.loading = false;
        this.done = true;
        setTimeout(() => this.router.navigate(['/login']), 2500);
      },
      (err: any) => {
        this.loading = false;
        this.rest.errorToaster(err?.error?.message || 'toast.invalid_reset_link');
      }
    );
  }
}
